'use client';

import { AppProgressProvider as ProgressProvider } from '@bprogress/next';

import { type TLayoutProps } from './types';

const OPTIONS = { showSpinner: false };

const ProgressIndicator = ({ children }: TLayoutProps) => (
  <ProgressProvider color="#c00" options={OPTIONS} shallowRouting>
    {children}
  </ProgressProvider>
);

export default ProgressIndicator;
